import './Loading.scss';

const LoginModal = (onClose = false) => {
  return (
    <div className="loadPop">
      <div className="modalContainer">
        <p>Loading...</p>
      </div>
        
    </div>
  );
};

export default LoginModal;